export const teamMembers = [
  {
    name: "Dr. Prosper Yirsob Andey (OD)",
    role: "Chief Executive Officer (CEO)",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 11,
  },
  {
    name: "Dr Maame Serwaa Achampong-Kyei (OD)",
    role: "Chief Operating Officer (COO)",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 6,
  },
  {
    name: "Dr. Afenyo Farida Selase (OD)",
    role: "Administrative Assistant/Secretary",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 4,
  },
  {
    name: "Dr. Danso Yaw Poakwa (OD)",
    role: "Procurement Oficer",
    bio: "Software Engineer and Tech Lead passionate about building scalable solutions and driving innovation across Africa’s tech ecosystem.",
    image: 0,
  },
  // {
  //   name: "Dr Agyei-Poku Akua Agyeiwaa (OD)",
  //   role: "Chief Financial Officer",
  //   bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
  //   image: 27,
  // },
  {
    name: "Dr Julian Sakyibea Yeboah (OD)",
    role: "Chief Financial Officer",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 5,
  },
  {
    name: "Dr. Joana Dedokwor Asare (OD)",
    role: "Human Resources Manager",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 7,
  },
  {
    name: "Dr. Charlotte Adjei (OD)",
    role: "Outreach And Community Education Head",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 23,
  },
  {
    name: "Dr. Janet Adjei (OD)",
    role: "Deputy Outreach & Community Education Head",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 3,
  },
  {
    name: "Dr. Reginald Gyamfi Acquah (OD)",
    role: "Director of Research Department",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 10,
  },
  {
    name: "Dr. Samuel Ofori Amoako (OD)",
    role: "Public Relations Officer",
    bio: "Driving impactful partnerships, shaping collaborations, and ensuring strong governance across all external relationships.",
    image: 1,
  },
  {
    name: "Afia Twewaa Asamoa (OD)",
    role: "Head of Media",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 13,
  },
  {
    name: "Dr. Anyimadze Samuel Turkson (OD)",
    role: "Deputy Media Head",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 14,
  },
  {
    name: "Dr Josephine Asare Yeboah (OD)",
    role: "Social Media & Digital Marketing Officer",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 12,
  },
  {
    name: "Dr. Afriyie Bonsu Yaa Agyapomaa (OD)",
    role: "Social Media and Digital Marketing Officer",
    bio: "Creative digital strategist and design lead focused on crafting impactful user experiences and visually compelling digital solutions.",
    image: 2,
  },
  {
    name: "Dr Kenneth Osei Tutu Boateng (OD)",
    role: "Photography, Videography and Content creation Head",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 8,
  },
  {
    name: "Dr. Kyei Baffour Michael (OD)",
    role: " Photography, Videography and Content creation (Deputy Head)",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 9,
  },
];
export const kumasiMembers = [
  {
    name: "Stephanie Nana Achiaa Owusu",
    role: "President",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 22
  },
  {
    name: "Boatey Pomaah Edna",
    role: "Vice President",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 21
  },
  {
    name: "Ayerkie Christabel Nuertey",
    role: "General secretary",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 20
  },
  {
    name: "Mary Sintim",
    role: "Financial Controller",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 24,
  },
  {
    name: "Fonore Wisdom Adongo ",
    role: "Organizer",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 19,
  },
  {
    name: "Aduah Wepasuah Anita ",
    role: "Research Head",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 18,
  },
  {
    name: "Ahenkan Loretta Yeboah",
    role: "Outreach head",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 16,
  },
  {
    name: "Esi Bomfowaa Eshun",
    role: "Assistant Outreach Head",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 17, 
  },
  {
    name: "Eugene Nana Sefah",
    role: "Media Head",
    bio: "Web development lead specializing in building responsive, high-performance applications and leading teams to deliver scalable digital solutions.",
    image: 15,
  },
];

export const boardMembers = [
  {
    name: "Prof. Mohammed Abdul-Kabir",
    role: "Patron",
    bio: "Head of Department (Optometry and Visual Science, KNUST) ",
    image: 25
  },
  {
    name: "Dr. Ruqyah Odumah Domson (OD)",
    role: "Board of Advisors",
    bio: "Watborg Eye Services",
    image: 26
  },
  {
    name: "Dr. Sylvester Kyeremeh",
    role: "Lecturer",
    bio: "Department of Optometry and Visual Science, KNUST",
    image: 28
  },
];


export const blogPosts = [
  {
    id: "ray-healthcare-eastern-region-super-zonals",
    title: "R.A.Y. Healthcare Africa Brings Vision Care to the Eastern Region Super Zonals Sports Competition",
    tag: "Healthcare & Community Outreach",
    author: "R.A.Y. Healthcare Africa",
    date: "May 7, 2025",
    excerpt:
      "From 5th–7th May 2025, R.A.Y. Healthcare Africa participated in the Eastern Region Super Zonals Sports Competition, providing vision screening and eye health education to thousands of students.",
    image: 0,
    time: "6 min read",
  },
  {
    id: "ray-healthcare-gnat-annual-meeting",
    title: "R.A.Y. Healthcare Africa Supports Educators with Vision Screening at GNAT Annual Meeting",
    tag: "Healthcare & Education",
    author: "R.A.Y. Healthcare Africa",
    date: "July 24, 2025",
    excerpt:
      "On 23rd–24th July 2025, R.A.Y. Healthcare Africa joined the GNAT Annual Meeting in the Brong Ahafo Region, offering vision screening and eye health education to educators.",
    image: 1,
    time: "6 min read",
  },
  {
    id: "ray-healthcare-lemps-foundation-shai-osudoku-outreach",
    title: "R.A.Y. Healthcare Africa Partners with LEMPs Foundation to Deliver Vision Care in Shai Osudoku Communities",
    tag: "Community Healthcare Outreach",
    author: "R.A.Y. Healthcare Africa",
    date: "November 29, 2025",
    excerpt:
      "On 29th November 2025, R.A.Y. Healthcare Africa partnered with LEMPs Foundation to deliver vision screening and eye health education in farming communities within the Shai Osudoku District.",
    image: 2,
    time: "6 min read",
  },
  {
    id: "ray-healthcare-feed-the-streets-koforidua",
    title: "R.A.Y. Healthcare Africa Partners with St Joana Foundation for “Feed the Streets” Outreach in Koforidua",
    tag: "Community Outreach & Healthcare",
    author: "R.A.Y. Healthcare Africa",
    date: "December 20, 2025",
    excerpt:
      "On 20th December 2025, R.A.Y. Healthcare Africa partnered with St. Joana Foundation for the Feed the Streets campaign in Koforidua, supporting donation and health screening activities.",
    image: 3,
    time: "6 min read",
  },
  {
    id: "ray-healthcare-all-hearts-foundation-outreach",
    title: "R.A.Y. Healthcare Africa Partners with All Hearts Foundation to Support Children at Chosen Children Center",
    tag: "Healthcare & Community Outreach",
    author: "R.A.Y. Healthcare Africa",
    date: "December 28, 2025",
    excerpt:
      "On 28th December 2025, R.A.Y. Healthcare Africa partnered with All Hearts Foundation during a donation outreach at Chosen Children Center in Accra.",
    image: 4,
    time: "6 min read",
  },
  {
    id: "ray-healthcare-ubuntu-inter-orphanage-games-2026",
    title: "Vision Beyond the Game: R.A.Y. Healthcare Africa at the Ubuntu Inter Orphanage Games",
    tag: "Healthcare & Community Outreach",
    author: "R.A.Y. Healthcare Africa",
    date: "January 10, 2026",
    excerpt:
      "On 10th January 2026, the University of Ghana Stadium hosted the Ubuntu Inter Orphanage Games by Black Sheep Foundation, bringing together children from various orphanages in a vibrant celebration of unity and joy.",
    image: 5,
    time: "6 min read",
  },
  {
    id: "ray-healthcare-world-glaucoma-awareness-week",
    title: "Shining Light on the Silent Thief of Sight: R.A.Y. Healthcare Africa Marks World Glaucoma Awareness Week",
    tag: "Healthcare & Awareness",
    author: "R.A.Y. Healthcare Africa",
    date: "March 2026",
    excerpt:
      "In recognition of World Glaucoma Awareness Week, R.A.Y. Healthcare Africa launched an online campaign to educate the public about glaucoma, a leading cause of irreversible blindness worldwide.",
    image: 6,
    time: "6 min read",
  },
  {
    id: "ray-healthcare-gnat-eye-screening-2026",
    title: "R.A.Y. Healthcare Africa Returns for Second Year of Eye Screening at GNAT Annual Meeting",
    tag: "Healthcare & Community Outreach",
    author: "R.A.Y. Healthcare Africa",
    date: "May 1, 2026",
    excerpt:
      "For the second consecutive year, R.A.Y. Healthcare Africa partnered with GNAT at their Brong Ahafo annual meeting, providing vision screening and eye health education for educators.",
    image: 7,
    time: "6 min read",
  },
  // {
  //   id: "smart-technology-africa-digital-transformation",
  //   title: "Building the Future: How Smart Technology is Transforming Africa’s Digital Landscape",
  //   tag: "Technology",
  //   author: "ClueCode",
  //   date: "2025-09-01",
  //   excerpt:
  //     "IoT sensors and real-time analytics helping farmers make informed decisions.",
  //   image: 8,
  //   time: "5 min read",
  // },
];

export const testimonials = [
  {
    quote:
      "R.A.Y. Healthcare has brought eye care to our doorstep. It's something our school has needed for a long time.",
    name: "School Administrator",
    title: "Education Sector",
    avatar: "SA",
  },
  {
    quote:
      "We are grateful for this screening. Several students have been referred for further care, and that could be life-changing.",
    name: "Teacher",
    title: "Educator",
    avatar: "T",
  },
  {
    quote:
      "I've never had an eye test before. It was quick, easy, and now I feel better knowing my eyes are okay.",
    name: "Kwaku Owusu",
    title: "Student",
    avatar: "KO",
  },
];
